import {
  Text as MantineText,
  createPolymorphicComponent,
  TextProps as MantineTextProps,
} from '@mantine/core';

import { forwardRef } from 'react';
import { TextParams, useStyles } from './Text.styles';

export interface TextProps extends MantineTextProps, TextParams {}

export type TextType = React.FC<TextProps>;
//  Todo: Move to Storybook or other style doc.
/**
 * Text component
 *
 * Based on: https://mantine.dev/core/text/
 *
 * E.g with styled components:
 *  ```TSX
 *  import  Text, {TextType} from '@components/Text/Text';
 *  import {cloneStyled} from '@utils';
 *  const DetailText = cloneStyled(
 *    Text,
 *    styled(Text)`
 *      white-space: pre-wrap;
 *      padding-left: 6px;
 *    `,
 *  );
 *
 * const DetailTextEg2 =   styled(Text)`
 *      white-space: pre-wrap;
 *      padding-left: 6px;
 * ` as TextType;
 *  ```
 *
 * Prefer using classNames though, or create a wrapper (See [TagNum](../TagNum/TagNum.tsx))
 */
const _Text = forwardRef<HTMLDivElement, TextProps>((props, ref) => {
  const { text, textColor, className, ...others } = props;
  const { classes, cx } = useStyles({
    text,
    textColor,
    inherit: others.inherit,
  });

  return (
    <MantineText
      ref={ref}
      className={cx(classes.root, className)}
      {...others}
    />
  );
});

const Text = createPolymorphicComponent<'div', TextProps>(_Text as TextType);
export default Text;
